import React from "react";
import { RouteComponentProps } from "react-router";
import FullPageSpinner from "components/FullPageSpinner/FullPageSpinner";
import { ReduxState, ReduxDispatch } from "ducks/reducers";
import {
    getEIDentifyLoading,
    startEIdentifyAuthentication,
    getEIdentifyLoginData,
    EIdentifySuccessResponse,
} from "ducks/eidentify";
import { connect } from "react-redux";
import { LoginResult } from "util/DTOs/UserDtos";
import { TOKEN_KEY, eidentifyLogin } from "ducks/user";
import { getStorage } from "util/storage";

export interface IEIdentifySuccessPageProps {
    loadingData: boolean;
    loginData: EIdentifySuccessResponse | null;
}

export interface IEIdentifySuccessPageDispatchProps {
    loadAuthentication: (code: string, action: string) => Promise<void>;
    login: (loginResult: LoginResult) => void;
}

type EIdentifySuccessPageProps = IEIdentifySuccessPageProps &
    IEIdentifySuccessPageDispatchProps &
    RouteComponentProps<any>;

function getUrlParameter(name: string, searchString: string) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    let regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    let results = regex.exec(searchString);
    return results === null
        ? ""
        : decodeURIComponent(results[1].replace(/\+/g, " "));
}

class EIdentifySuccessPage extends React.Component<EIdentifySuccessPageProps> {
    componentDidMount() {
        const code = getUrlParameter("code", this.props.location.search);
        const action = getUrlParameter("state", this.props.location.search);
        if (code) {
            this.props.loadAuthentication(code, action).then(() => {
                if (
                    this.props.loginData &&
                    this.props.loginData.action === 1 &&
                    this.props.loginData.hash
                ) {
                    this.props.history.push(
                        `/register/${this.props.loginData.hash}`
                    );
                } else if (
                    this.props.loginData &&
                    this.props.loginData.action === 2 &&
                    this.props.loginData.tokenResponse
                ) {
                    this.props.login(this.props.loginData.tokenResponse);
                    this.props.history.push("/");
                } else if (
                    this.props.loginData &&
                    this.props.loginData.action === 3 &&
                    this.props.loginData.hash
                ) {
                    this.props.history.push(
                        `/profile/changepassword/${this.props.loginData.hash}`
                    );
                } else if (
                    this.props.loginData &&
                    this.props.loginData.action === 4 &&
                    this.props.loginData.hash
                ) {
                    this.props.history.push(
                        `/profile/createlogin/${this.props.loginData.hash}`
                    );
                } else {
                    this.props.history.push("/eidentify/error");
                }
            });
        }
    }

    public render() {
        return (
            <div className="eidentify-page">
                <FullPageSpinner loading={this.props.loadingData} />
            </div>
        );
    }
}

const mapStateToProps = (state: ReduxState): IEIdentifySuccessPageProps => {
    return {
        loadingData: getEIDentifyLoading(state),
        loginData: getEIdentifyLoginData(state),
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): IEIdentifySuccessPageDispatchProps => {
    return {
        loadAuthentication: (code: string, action: string) =>
            dispatch(startEIdentifyAuthentication(code, action)),
        login: (loginResult: LoginResult) =>
            dispatch(eidentifyLogin(loginResult)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EIdentifySuccessPage);



// WEBPACK FOOTER //
// ./src/views/eidentify/EIdentifySuccess.tsx